import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import ProgressBar from "../../progress_bar";

const PROGRESS_BAR_WIDTH = 200;

export default GrComponentFactory.createClass({
  displayName: "ReadingChallengeJoinDetails",
  propTypes: {
    user: GrPropTypes.user().isRequired,
    goalNum: React.PropTypes.number.isRequired,
    numRead: React.PropTypes.number.isRequired,
    challenge: React.PropTypes.shape({
      title: React.PropTypes.string.isRequired,
    }),
  },

  renderBookNumText() {
    return `${this.props.goalNum} ${this.props.goalNum === 1 ? "book" : "books"}`;
  },

  render() {
    return <div className="gr-newsfeedItem__details">
             Cheer {this.props.user.viewableName}!
             <div className="readingChallengeNewsfeedItem__challengeDescription">
               {this.props.user.viewableName} has set a goal of reading {""}
               {this.renderBookNumText()} for the {this.props.challenge.title}!
             </div>
             <ProgressBar value={this.props.numRead}
                          max={this.props.goalNum}
                          width={PROGRESS_BAR_WIDTH}
                          progressText={`${Math.floor((this.props.numRead / this.props.goalNum) * 100)}%`} />
             <small>{this.props.numRead} of {this.props.goalNum} books read</small>
           </div>;
  },
});
